import styled from "styled-components";

export const ButtonContainer = styled.button`
  text-transform: capitalize;
  background: transparent;
  border: 2px solid var(--lightBlue);
  border-color: ${props => (props.cart ? "var(--yellow)" : "var(--lightBlue)")};
  border-radius: 0.2rem;
  margin: 0 1rem 1rem 0;
  padding: 0.3rem 1rem;
  cursor: pointer;
  transition: 0.3s all;

  &:hover {
    background-color: ${props =>
      props.cart ? "var(--yellow)" : "var(--lightBlue)"};
  }
`;
